import { FormControl } from "@chakra-ui/react";
import React from "react";
import { SearchBar } from "../../molecules/forms/SearchBar";

export type SelectorSearchProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchRef: React.RefObject<HTMLInputElement>;
  onSearchKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
};

export function SelectorSearch({
  searchValue,
  onSearchChange,
  searchRef,
  onSearchKeyDown,
}: SelectorSearchProps) {
  // The SearchBar component has an Input field, which inherits the isInvalid
  // state from any outer FormControl. This isn't desired here, as the Selector
  // itself has its own error state. We wrap the search inside its own
  // FormControl so it never gets error styling.
  return (
    <FormControl isInvalid={false}>
      <SearchBar
        backgroundColor="white"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        inputRef={searchRef}
        onKeyDown={onSearchKeyDown}
      />
    </FormControl>
  );
}
